<!-- <div class="px-2 px-sm-3 py-3 py-sm-3 py-lg-4">
  <ul class="list-group list-group-flush">
    <li class="list-group-item fw-bold cdc1">Manage Staff WhatsApp</li>
    <li class="list-group-item cdc1">Manage Kategori</li>
    <li class="list-group-item cdc1">Manage Dokument</li>
    <li class="list-group-item cdc1">Mapping Kategori Dokument</li>
  </ul>
</div> -->


<!-- <div class="">

  <nav class="d-flex flex-wrap text-center nav mt-sm-3 mt-lg-1">
    <li class="flex-fill nav-item nav-rfq px-3 py-2" routerLinkActive="border-bottom border1 border-2 active-link">
      <a class="nav-link mn-color" routerLink="/setting/wa-staff-management">Staff Management</a>
    </li>
    <li class="flex-fill nav-item nav-rfq px-3 py-2" routerLinkActive="border-bottom border1 border-2 active-link">
      <a class="nav-link mn-color" routerLink="/setting/wa-category-management">Category Management</a>
    </li>
    <li class="flex-fill nav-item nav-rfq px-3 py-2" routerLinkActive="border-bottom border1 border-2 active-link">
      <a class="nav-link mn-color" routerLink="/setting/wa-document-management">Document Management</a>
    </li>
    <li class="flex-fill nav-item nav-rfq px-3 py-2" routerLinkActive="border-bottom border1 border-2 active-link">
      <a class="nav-link mn-color" routerLink="/setting/wa-mapping-category-document">Mapping Category Document</a>
    </li>
  </nav>

</div> -->


        <div class="divsubscription pb-3">
          <div class="row g-0 justify-content-center pb-3">
            <div class="col-12">
              <nav class="d-flex flex-wrap text-center nav mt-sm-3 mt-lg-1">

                <li class="flex-fill nav-item nav-rfq px-0 pt-2" routerLinkActive="active-link">
                  <a class="nav-link mn-color" routerLink="/setting/wa-user-management" routerLinkActive="border-bottom border1 border-2">
                    <i class="fas fa-shopping-bag me-2"></i>Pengaturan Staff
                  </a>
                </li>

                <li class="flex-fill nav-item nav-rfq px-0 pt-2" routerLinkActive="active-link">
                  <a class="nav-link mn-color" routerLink="/setting/wa-category" routerLinkActive="border-bottom border1 border-2">
                    <i class="fas fa-list me-2"></i>Pengaturan Kategori
                  </a>
                </li>

                <li class="flex-fill nav-item nav-rfq px-0 pt-2" routerLinkActive="active-link">
                  <a class="nav-link mn-color" routerLink="/setting/wa-files-management" routerLinkActive="border-bottom border1 border-2">
                    <i class="fas fa-file me-2"></i>Upload File
                  </a>
                </li>

                <li class="flex-fill nav-item nav-rfq px-0 pt-2" routerLinkActive="active-link">
                  <a class="nav-link mn-color" routerLink="/setting/wa-role-category-mapping" routerLinkActive="border-bottom border1 border-2">
                    <i class="fas fa-project-diagram me-2"></i>Mapping Role & Kategori
                  </a>
                </li>
              </nav>
            </div>
          </div>
        </div>
